export const bindPointerEvents = (mouseRef, scrollRef, sizeOf) => {
  const onMove = (e) => {
    const { fullWidth, fullHeight } = sizeOf();
    mouseRef.current.targetX = e.clientX / fullWidth;
    mouseRef.current.targetY = e.clientY / fullHeight;
  };
  const onScroll = () => {
    scrollRef.current.target = window.scrollY;
  };
  window.addEventListener('mousemove', onMove);
  window.addEventListener('scroll', onScroll, { passive: true });
  return () => {
    window.removeEventListener('mousemove', onMove);
    window.removeEventListener('scroll', onScroll);
  };
};
